import React from "react";
import type { FlipCallbacks } from "./types";

export const FlipContext = React.createContext(null as unknown as FlipCallbacks);
